import { useEffect, useState } from 'react';

import client from '../api/client';

// GET /api/category?parentId=... -> immediate children (or top-level, when
// parentId is null) of the given category. Mirrors useCategories.js's shape.
// `enabled: false` skips the fetch entirely (e.g. CategoryPage only needs
// this on non-leaf/root views, not on leaf category pages).
export default function useCategoryChildren(parentId, enabled = true) {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!enabled) {
      setLoading(false);
      return undefined;
    }
    let active = true;
    setLoading(true);
    client
      .get('/category', { params: { parentId: parentId == null ? 'root' : parentId } })
      .then(({ data }) => {
        if (!active) return;
        setCategories(Array.isArray(data) ? data : []);
        setError(null);
      })
      .catch((err) => {
        if (active) setError(err);
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, [parentId, enabled]);

  return { categories, loading, error };
}
